import React from 'react'
import { ArrowUpRight, ArrowDownRight } from 'lucide-react'
import { cn } from '../../utils/cn'
import { inrSigned, pct as fmtPct } from '../../utils/format'

/**
 * Delta — a signed gain/loss figure with refined up/down language.
 * Accepts either a rupee `value`, a `pct`, or both. Color + arrow follow the sign.
 *
 *   <Delta value={1240} pct={2.4} />     → ▲ +₹1,240  +2.40%
 *   <Delta pct={-0.8} arrow={false} />   → −0.80%
 */
export default function Delta({
  value, pct, compact = false, arrow = true, size = 'sm', className,
}) {
  const basis = value != null ? value : pct
  if (basis == null) return <span className={cn('text-ink-300', className)}>—</span>
  const up = Number(basis) >= 0
  const Arrow = up ? ArrowUpRight : ArrowDownRight
  const sizes = { xs: 'text-xs', sm: 'text-sm', md: 'text-[15px]', lg: 'text-base' }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-semibold tabular-nums',
        up ? 'text-gain-600' : 'text-loss-600',
        sizes[size] || sizes.sm,
        className,
      )}
    >
      {arrow && <Arrow className="w-3.5 h-3.5 shrink-0" strokeWidth={2.5} />}
      {value != null && <span>{inrSigned(value, { compact })}</span>}
      {pct != null && <span className={value != null ? 'text-[0.85em] opacity-80' : ''}>{fmtPct(pct)}</span>}
    </span>
  )
}
